import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * On every route change, scroll the window to the top — the standard SPA
 * behavior that react-router does not provide by default. If the URL carries an
 * in-page #anchor, honor that instead so anchor links still land on the section.
 * Query-only changes (same pathname) are ignored so flows like payment returns
 * or pagination don't jump.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
